var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"sortable-handle",class:{'disabled': !_vm.sortable}},[_c('i',{staticClass:"far",class:_vm.sortable ? 'fa-grip-lines' : 'fa-ban'})])}
var staticRenderFns = []

export { render, staticRenderFns }